// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'eye-off';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m2.085 15.75 14.063-13.5M6.75 14.287a7.434 7.434 0 0 0 2.25.338c3.075.052 6.195-2.107 8.115-4.23a1.238 1.238 0 0 0 0-1.665 15.049 15.049 0 0 0-2.302-2.07m-1.995-1.208A8.482 8.482 0 0 0 9 4.5C6 4.447 2.85 6.562.885 8.73a1.238 1.238 0 0 0 0 1.665 15 15 0 0 0 3.697 3' />
    <path d='M6.75 11.303a2.887 2.887 0 0 1 4.125-3.96m.938 2.22A2.811 2.811 0 0 1 9 12.374' />
  </g>
);

export const viewBox = '0 0 18 18';
